<template>
  <div class="container admin">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>权限管理</el-breadcrumb-item>
        <el-breadcrumb-item>管理员管理</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">管理员管理</h2>
        </div>
        <div class="right">
          <el-button
            class="button"
            type="primary"
            @click="handleAdminCreate"
          >添加管理员</el-button>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form
        class="search-wrap"
        ref="searchForm"
        :inline="true"
        :model="query"
      >
        <el-form-item
          label="用户名称"
          prop="keyword"
        >
          <el-input
            v-model="query.keyword"
            placeholder="输入用户名称/手机号"
            @input="fetchAdminList(true)"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          label="角色"
          prop="role"
        >
          <el-select
            v-model="query.role"
            placeholder="请选择"
            @change="fetchAdminList(true)"
            clearable
          >
            <el-option
              v-for="(item,index) in roleList"
              :key="index"
              :label="item.title"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="状态"
          prop="status"
        >
          <el-select
            v-model="query.status"
            placeholder="请选择"
            @change="fetchAdminList(true)"
            clearable
          >
            <el-option
              v-for="item in filter.status"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="results card">
      <div class="values-header">
        <p class="title">查找结果</p>
      </div>
      <div class="values">
        <el-table
          class="table"
          :data="results"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="id"
            label="ID"
            width="80"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="username"
            label="用户名称"
            min-width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="nickname"
            label="昵称"
            min-width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="mobile"
            label="手机号"
            min-width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="roles"
            label="角色"
            min-width="160"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ roleRilter(scope.row.roles, roleList) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="roles"
            label="部门"
            min-width="160"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ deptRilter(scope.row.depts, deptList) }}
            </template>
          </el-table-column>
          <!-- <el-table-column
            label="登录时间"
            min-width="160"
            align="center">
            <template >
              <div>

              </div>
            </template>
          </el-table-column> -->
          <el-table-column
            label="状态"
            width="80"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag
                size="mini"
                :type="scope.row.status == 1 ? 'success' : 'danger'"
              >{{
                scope.row.status == 1 ? "正常" : "禁用"
              }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="invitecode"
            label="邀请码"
            min-width="100"
            align="center"
          >
          </el-table-column>
          <!--      <el-table-column
            label="用户绑定"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.user_ref? scope.row.user_ref.nickname:'未绑定' }}
            </template>
          </el-table-column> -->
          <el-table-column
            label="操作"
            width="100"
            align="center"
            fixed="right"
            v-if="isfixed"
          >
            <template slot-scope="scope">
              <!--      <el-button
                size="mini"
                type="text"
                @click="handleToSet(scope.row)"
              >绑定用户</el-button> -->
              <el-button
                size="mini"
                type="text"
                @click="handleToAdminEdit(scope.row, scope.$index)"
              >编辑</el-button>
              <!--      <el-button
                size="mini"
                type="text"
                @click="handleToAddRole(scope.row, scope.$index)"
              >角色分配</el-button> -->
              <el-button
                size="mini"
                style="color: #f56c6c"
                type="text"
                @click="handleToRuleDelete(scope.row, scope.$index)"
              >删除</el-button>
            </template>
          </el-table-column>
          <el-table-column
            label=""
            width="40"
            align="center"
            fixed="right"
            v-else
          >
            <template slot-scope="scope">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                  ...
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    command="a"
                    style="margin-bottom:6px;"
                  ><span
                      @click="handleToAdminEdit(scope.row, scope.$index)"
                      style="font-size:16px;color: #409EFF;"
                    >
                      编辑
                    </span></el-dropdown-item>
                  <el-dropdown-item
                    command="b"
                    style="margin-bottom:6px;"
                  ><span
                      @click="handleToSet(scope.row)"
                      style="font-size:16px;color: #409EFF;"
                    >
                      绑定用户
                    </span></el-dropdown-item>
                  <el-dropdown-item
                    command="c"
                    style="margin-bottom:6px;"
                  ><span
                      @click="handleToAddRole(scope.row, scope.$index)"
                      style="font-size:16px;color: #409EFF;"
                    >
                      角色分配
                    </span></el-dropdown-item>
                  <el-dropdown-item
                    command="d"
                    style="margin-bottom:6px;"
                  ><span
                      @click="handleToRuleDelete(scope.row, scope.$index)"
                      style="font-size:16px;color: #F56C6C;"
                    >
                      删除
                    </span></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
    <AdminCreate
      :visible="createDialog"
      @close="createDialog = false"
      @submit="fetchAdminList"
    ></AdminCreate>
    <AdminEdit
      :visible="editDialog"
      :content="editRow"
      @close="editDialog = false"
      @submit="fetchAdminList"
    ></AdminEdit>
    <AdminAddRole
      :visible="roleDialog"
      :content="editRow"
      @close="roleDialog = false"
      @submit="fetchAdminList"
    ></AdminAddRole>
    <MemberChooseSingle
      :visible="userChooseDialog"
      @close="userChooseDialog = false"
      @submit="saveMember"
    ></MemberChooseSingle>
  </div>
</template>

<script>
import {
  adminList,
  adminRoleList,
  adminDestroy,
  adminUpdate,
  adminPermissions,
  deptlist
} from "@/api/admin";
import AdminCreate from "@/components/dialog/admin/AdminCreate";
import MemberChooseSingle from "@/components/dialog/member/MemberChooseSingle";
import AdminEdit from "@/components/dialog/admin/AdminEdit";
import AdminAddRole from "@/components/dialog/admin/AdminAddRole";
import { setStorage } from "@/utils/helper";

export default {
  components: {
    AdminCreate,
    AdminEdit,
    AdminAddRole, MemberChooseSingle
  },
  data() {
    return {
      createDialog: false,
      editDialog: false,
      roleDialog: false,
      editRow: {},
      query: {
        keyword: "",
        status: "",
        role: "",
        pageIndex: 1,
        pageSize: localStorage.getItem("pageSize")
          ? Number(localStorage.getItem("pageSize"))
          : 10,
        isPaging: 1,
      },
      pageTotal: 1000,
      filter: {
        status: [
          { label: "全部", value: "" },
          { label: "正常", value: "1" },
          { label: "禁用", value: "0" },
        ],
        roles: [
          { label: "全部", value: "" },
          { label: "管理员", value: "1" },
          { label: "运营", value: "2" },
        ],
      },
      results: [],
      roleList: [],
      deptList: [],
      userChooseDialog: false,
      MemberChooseSingleContent: {},
      isfixed: document.body.clientWidth < 820 ? false : true,
    };
  },
  created() {
    this.parseQuery();
    this.fetchAdminList();
    this.fetchAdminRoleList();
    this.fetchAdminDeptList()
  },
  methods: {
    // 管理员列表
    fetchAdminList(isReset = false) {
      if (isReset) {
        this.$set(this.query, "pageIndex", 1);
      }
      adminList(this.query).then((res) => {
        this.results = res.list || [];
        this.pageTotal = res.count || 0;
      });
      this.syncQuery();
    },
    //角色列表
    fetchAdminRoleList() {
      adminRoleList({ isPaging: 0 }).then((res) => {
        this.roleList = res.list;
      });
    },
    // 部门列表
    fetchAdminDeptList() {
      deptlist({ isPaing: 0 }).then(res => {
        this.deptList = res.list
      })
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      localStorage.setItem("pageSize", val);
      this.fetchAdminList();
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, "pageIndex", val);
      this.fetchAdminList();
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, "pageIndex", 1);
      this.fetchAdminList();
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields();
      this.fetchAdminList();
    },
    // 部分内容渲染
    handleRender(value, type) {
      let status = {
        1: "正常",
        0: "禁用",
      };
      if (type == "status") {
        return status[value] || "";
      }
      return "";
    },
    // 管理员编辑
    handleToAdminEdit(row) {
      this.editRow = Object.assign({}, row, {
        status: row.status == 1 ? true : false,
      });
      this.editDialog = true;
    },
    // 管理员创建
    handleAdminCreate() {
      this.createDialog = true;
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key];
      });
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      );
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        });
    },
    handleToAddRole(item, index) {
      this.editRow = item;
      this.roleDialog = true;
    },
    roleRilter(row, roleList) {
      let role = [];
      let arr = row.split(",");
      arr.forEach((v) => {
        if (
          roleList.findIndex((i) => {
            return i.id == v;
          }) == -1
        ) {
          return;
        } else {
          role.push(
            roleList.find((i) => {
              return i.id == v;
            }).title
          );
        }
      });
      return String(role);
    },
    deptRilter(row, deptList) {
      let role = [];
      let arr = row.split(",");
      arr.forEach((v) => {
        if (
          deptList.findIndex((i) => {
            return i.id == v;
          }) == -1
        ) {
          return;
        } else {
          role.push(
            deptList.find((i) => {
              return i.id == v;
            }).name
          );
        }
      });
      return String(role);
    },
    handleToRuleDelete(item, index) {
      this.$confirm("确定要删除选中的数据吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          adminDestroy({ id: item.id }).then((res) => {
            this.fetchAdminList();
          });
        })
        .catch(() => {
          this.$message.error("已取消删除");
        });
    },
    saveMember(users) {
      console.log(users);
      let params = {
        id: this.MemberChooseSingleContent.id,
        uid_ref: users.users.id
      }
      adminUpdate(params)
        .then((res) => {
          this.$message.success(`修改成功`);
          this.userChooseDialog = false
        })
        .catch((error) => {
          console.log("error: ", error);
        });
    },
    handleToSet(item) {
      this.userChooseDialog = true
      this.MemberChooseSingleContent = JSON.parse(JSON.stringify(item))
    }
  },
};
</script>

<style scoped lang="less">
.admin {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
</style>
